import {getRoleFromPost} from "@hosttools/core/shared/getRoleFromPost";
import {useMemo} from "react";

import type {ReservationPost} from "../../../models/reservation";
import type {Post} from "../useReservationPosts/share";

export function useLastPost(posts: Post[] | undefined, order: "asc" | "desc" = "asc") {
    return useMemo(() => {
        const postsOnly = posts?.reduce<ReservationPost[]>((result, post) => {
            if (post.post.type === "post") {
                result.push(post.post.data);
            }
            return result;
        }, []);

        const last = postsOnly?.length
            ? postsOnly[order === "desc" ? 0 : postsOnly.length - 1]
            : undefined;

        return last ? {...last, role: getRoleFromPost(last)} : undefined;
    }, [order, posts]);
}
